<template>
  <div id="appCurrentSession">
  <!-- Include live sessions side bar -->
<div class="live-sessions" id="live-sessions" v-if="cmSession !=null && cmSession.data != null  && cmSession.data.CurrentSessionsList.length > 0" >
    
 
  <p class="live-sessions-title">{{cmSession.data.config.SessionstitleLabel}}</p>


  <div v-for="(cmCurrentSession, index) in cmSession.data.CurrentSessionsList" :key="cmCurrentSession.id" :class="{'live-sessions-card card--live-session--blue': index % 2 === 0, 'live-sessions-card card--live-session--orange': index % 2 !== 0 }">
    <div class="card-inner">
      <div class="card-time-room-cont disp--flex just--betw card-mar-bot">
        <div class="card-time-cont">
          <span>{{cmSession.data.config.Startlabel}} </span><span class="card-time">{{ getstarttime(cmCurrentSession.StartTime) }}</span>
        </div>
        <div class="card-room-cont">
          <span>{{cmSession.data.config.Roomlabel}} </span><span class="card-room">{{cmCurrentSession.Room}}</span>
        </div>
      </div>
      <div class="card-session-title-cont card-mar-bot">
        <div class="card-session-title">
          <p v-html="cmCurrentSession.Title">
          </p>
        </div>
      </div>
      <div class="card-session-chair-speakers-cont" >
        <div v-for="functionitem in cmCurrentSession.Functions" :key="functionitem.id"  :class="'card-session-'+ functionitem.FunctionName +'-cont card-mar-bot'">
          <span><strong>{{functionitem.FunctionName}} </strong></span><span class="card-session-chair">
            <span  v-for="(person, index) in functionitem.Persons" :key="person.id"  >
              {{person.Firstname}}<span v-html="cmSession.data.config.CharsBetweenFirstNameAndName"></span>{{person.Name}}<span v-html="cmSession.data.config.CharsBetweenNameAndCountry"></span><span v-if="cmSession.data.config.ShowCountry">{{person.Country}}</span><span v-if="index != Object.keys(functionitem.Persons).length - 1" v-html="cmSession.data.config.CharsAfterCountry"></span> 
            </span >
        </span>
        </div>
      </div>
      <div class="card-session-join" v-if="cmCurrentSession.ShowJoinButton && cmCurrentSession.Url != ''">
        <a :href="cmCurrentSession.Url">{{cmSession.data.config.ButtonText}}</a>
      </div>
    </div>
  </div>

</div>
<div v-else-if="cmSession !=null"  class="live-sessions NoSessions" id="live-sessions"  >
  <div class="live-sessions-card card--live-session--blue">
    <div class="card-inner">
      <span v-html="cmSession.data.config.NoSessionstext"></span>
    </div>
  </div>
</div>


  </div>
</template>

<script>
import Axios from 'axios'
import moment from 'moment'

export default {
  name: 'App', data () {
    return {
      cmSession: null,
      conferenceId:this.$cmCurrentSessiondata.conferenceId,
      sessionreturndata:null,
      firstload:true
    }
  },
  components: {
  },methods:{

    getstarttime:function(date){
      return moment(date).format('HH:mm')
    
    },
    geturlsession:function(url){
      if(url !=""){
      return url;
      }else{
          return "#";
      }
    
    },
    loadcurrentSessions:function(){
      Axios.post(  process.env.VUE_APP_APIURL +'/GetCurrentSessions/'+this.conferenceId +'/key',this.sessionreturndata
      )
      .then(response => {
        this.cmSession = response
        if(this.firstload==true){
           window.setInterval(() => {
            this.loadcurrentSessions()
          }, this.cmSession.data.config.RefreshtimeSeconds *1000)
          this.firstload=false
        }
			console.log(response);
      }).catch(error => {
      console.log(error);
			//this.nodatatext= process.env.VUE_APP_NOCONF
			
      });
    }
  },mounted: function () {
      this.loadcurrentSessions()

}
}
</script>

